An unposted profile of a position opening to create.
